// @ts-nocheck
/**
 * Generated by orval v7.5.0 🍺
 * Do not edit manually.
 * SUREnet documenten-internal API
 * OpenAPI spec version: 1
 */
import { useMutation, useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';
import { unref } from 'vue';
import type { MaybeRef } from 'vue';
import type { CollectionResultOfDocumentenSamenwerkingsovereenkomstGetSamenwerkingsovereenkomstOverzichtDto } from '../model/collectionResultOfDocumentenSamenwerkingsovereenkomstGetSamenwerkingsovereenkomstOverzichtDto';
import type { CollectionResultOfDocumentenSamenwerkingsovereenkomstVerstuurHerinneringenDto } from '../model/collectionResultOfDocumentenSamenwerkingsovereenkomstVerstuurHerinneringenDto';
import type { CollectionResultOfDocumentenSamenwerkingsovereenkomstVerstuurSamenwerkingsovereenkomstOndertekeningsverzoekBatchForEmailDto } from '../model/collectionResultOfDocumentenSamenwerkingsovereenkomstVerstuurSamenwerkingsovereenkomstOndertekeningsverzoekBatchForEmailDto';
import type { CollectionResultOfDocumentenSamenwerkingsovereenkomstVerstuurSamenwerkingsovereenkomstOndertekeningsverzoekBatchForUserDto } from '../model/collectionResultOfDocumentenSamenwerkingsovereenkomstVerstuurSamenwerkingsovereenkomstOndertekeningsverzoekBatchForUserDto';
import type { DocumentenSamenwerkingsovereenkomstVerstuurSamenwerkingsovereenkomstOndertekeningsverzoekBatchForEmailGebruikerDto } from '../model/documentenSamenwerkingsovereenkomstVerstuurSamenwerkingsovereenkomstOndertekeningsverzoekBatchForEmailGebruikerDto';
import type { SamenwerkingsovereenkomstBatchEmailParams } from '../model/samenwerkingsovereenkomstBatchEmailParams';
import type { SamenwerkingsovereenkomstBatchHerinneringenParams } from '../model/samenwerkingsovereenkomstBatchHerinneringenParams';
import type { SamenwerkingsovereenkomstBatchParams } from '../model/samenwerkingsovereenkomstBatchParams';
import type { SamenwerkingsovereenkomstOverzichtParams } from '../model/samenwerkingsovereenkomstOverzichtParams';
import { customInstance } from '../../customInstance';
import type { ErrorType } from '../../customInstance';

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.Adviseurbeheer</li></ul>
 * @summary Laat zien naar welke adviseurs de swo is verstuurd en of die al is ondertekend
 */
export const samenwerkingsovereenkomstOverzicht = (
  params?: MaybeRef<SamenwerkingsovereenkomstOverzichtParams>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customInstance<CollectionResultOfDocumentenSamenwerkingsovereenkomstGetSamenwerkingsovereenkomstOverzichtDto>(
    {
      url: `/api/v1/samenwerkingsovereenkomst/overzicht`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getSamenwerkingsovereenkomstOverzichtQueryKey = (
  params?: MaybeRef<SamenwerkingsovereenkomstOverzichtParams>,
) => ['api', 'v1', 'samenwerkingsovereenkomst', 'overzicht', ...(params ? [params] : [])] as const;

export const getSamenwerkingsovereenkomstOverzichtQueryOptions = <
  TData = Awaited<ReturnType<typeof samenwerkingsovereenkomstOverzicht>>,
  TError = ErrorType<void>,
>(
  params?: MaybeRef<SamenwerkingsovereenkomstOverzichtParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof samenwerkingsovereenkomstOverzicht>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getSamenwerkingsovereenkomstOverzichtQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof samenwerkingsovereenkomstOverzicht>>> = ({
    signal,
  }) => samenwerkingsovereenkomstOverzicht(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof samenwerkingsovereenkomstOverzicht>>,
    TError,
    TData
  >;
};

export type SamenwerkingsovereenkomstOverzichtQueryResult = NonNullable<
  Awaited<ReturnType<typeof samenwerkingsovereenkomstOverzicht>>
>;
export type SamenwerkingsovereenkomstOverzichtQueryError = ErrorType<void>;

/**
 * @summary Laat zien naar welke adviseurs de swo is verstuurd en of die al is ondertekend
 */

export function useSamenwerkingsovereenkomstOverzicht<
  TData = Awaited<ReturnType<typeof samenwerkingsovereenkomstOverzicht>>,
  TError = ErrorType<void>,
>(
  params?: MaybeRef<SamenwerkingsovereenkomstOverzichtParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof samenwerkingsovereenkomstOverzicht>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getSamenwerkingsovereenkomstOverzichtQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
 * @summary Verstuurt de SWO voor de opgegeven gebruikers.
 */
export const samenwerkingsovereenkomstBatch = (
  samenwerkingsovereenkomstBatchBody: MaybeRef<number[]>,
  params?: MaybeRef<SamenwerkingsovereenkomstBatchParams>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  samenwerkingsovereenkomstBatchBody = unref(samenwerkingsovereenkomstBatchBody);
  params = unref(params);

  return customInstance<CollectionResultOfDocumentenSamenwerkingsovereenkomstVerstuurSamenwerkingsovereenkomstOndertekeningsverzoekBatchForUserDto>(
    {
      url: `/api/v1/samenwerkingsovereenkomst/batch`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: samenwerkingsovereenkomstBatchBody,
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getSamenwerkingsovereenkomstBatchMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof samenwerkingsovereenkomstBatch>>,
    TError,
    { data: number[]; params?: SamenwerkingsovereenkomstBatchParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof samenwerkingsovereenkomstBatch>>,
  TError,
  { data: number[]; params?: SamenwerkingsovereenkomstBatchParams },
  TContext
> => {
  const mutationKey = ['samenwerkingsovereenkomstBatch'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof samenwerkingsovereenkomstBatch>>,
    { data: number[]; params?: SamenwerkingsovereenkomstBatchParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return samenwerkingsovereenkomstBatch(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SamenwerkingsovereenkomstBatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof samenwerkingsovereenkomstBatch>>
>;
export type SamenwerkingsovereenkomstBatchMutationBody = number[];
export type SamenwerkingsovereenkomstBatchMutationError = ErrorType<void>;

/**
 * @summary Verstuurt de SWO voor de opgegeven gebruikers.
 */
export const useSamenwerkingsovereenkomstBatch = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof samenwerkingsovereenkomstBatch>>,
    TError,
    { data: number[]; params?: SamenwerkingsovereenkomstBatchParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationReturnType<
  Awaited<ReturnType<typeof samenwerkingsovereenkomstBatch>>,
  TError,
  { data: number[]; params?: SamenwerkingsovereenkomstBatchParams },
  TContext
> => {
  const mutationOptions = getSamenwerkingsovereenkomstBatchMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
 * @summary Verstuurt de SWO voor de opgegeven tijdelijke emails.
 */
export const samenwerkingsovereenkomstBatchEmail = (
  documentenSamenwerkingsovereenkomstVerstuurSamenwerkingsovereenkomstOndertekeningsverzoekBatchForEmailGebruikerDto: MaybeRef<
    DocumentenSamenwerkingsovereenkomstVerstuurSamenwerkingsovereenkomstOndertekeningsverzoekBatchForEmailGebruikerDto[]
  >,
  params?: MaybeRef<SamenwerkingsovereenkomstBatchEmailParams>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  documentenSamenwerkingsovereenkomstVerstuurSamenwerkingsovereenkomstOndertekeningsverzoekBatchForEmailGebruikerDto =
    unref(
      documentenSamenwerkingsovereenkomstVerstuurSamenwerkingsovereenkomstOndertekeningsverzoekBatchForEmailGebruikerDto,
    );
  params = unref(params);

  return customInstance<CollectionResultOfDocumentenSamenwerkingsovereenkomstVerstuurSamenwerkingsovereenkomstOndertekeningsverzoekBatchForEmailDto>(
    {
      url: `/api/v1/samenwerkingsovereenkomst/batch/temp`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: documentenSamenwerkingsovereenkomstVerstuurSamenwerkingsovereenkomstOndertekeningsverzoekBatchForEmailGebruikerDto,
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getSamenwerkingsovereenkomstBatchEmailMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof samenwerkingsovereenkomstBatchEmail>>,
    TError,
    {
      data: DocumentenSamenwerkingsovereenkomstVerstuurSamenwerkingsovereenkomstOndertekeningsverzoekBatchForEmailGebruikerDto[];
      params?: SamenwerkingsovereenkomstBatchEmailParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof samenwerkingsovereenkomstBatchEmail>>,
  TError,
  {
    data: DocumentenSamenwerkingsovereenkomstVerstuurSamenwerkingsovereenkomstOndertekeningsverzoekBatchForEmailGebruikerDto[];
    params?: SamenwerkingsovereenkomstBatchEmailParams;
  },
  TContext
> => {
  const mutationKey = ['samenwerkingsovereenkomstBatchEmail'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof samenwerkingsovereenkomstBatchEmail>>,
    {
      data: DocumentenSamenwerkingsovereenkomstVerstuurSamenwerkingsovereenkomstOndertekeningsverzoekBatchForEmailGebruikerDto[];
      params?: SamenwerkingsovereenkomstBatchEmailParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return samenwerkingsovereenkomstBatchEmail(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SamenwerkingsovereenkomstBatchEmailMutationResult = NonNullable<
  Awaited<ReturnType<typeof samenwerkingsovereenkomstBatchEmail>>
>;
export type SamenwerkingsovereenkomstBatchEmailMutationBody =
  DocumentenSamenwerkingsovereenkomstVerstuurSamenwerkingsovereenkomstOndertekeningsverzoekBatchForEmailGebruikerDto[];
export type SamenwerkingsovereenkomstBatchEmailMutationError = ErrorType<void>;

/**
 * @summary Verstuurt de SWO voor de opgegeven tijdelijke emails.
 */
export const useSamenwerkingsovereenkomstBatchEmail = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof samenwerkingsovereenkomstBatchEmail>>,
    TError,
    {
      data: DocumentenSamenwerkingsovereenkomstVerstuurSamenwerkingsovereenkomstOndertekeningsverzoekBatchForEmailGebruikerDto[];
      params?: SamenwerkingsovereenkomstBatchEmailParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationReturnType<
  Awaited<ReturnType<typeof samenwerkingsovereenkomstBatchEmail>>,
  TError,
  {
    data: DocumentenSamenwerkingsovereenkomstVerstuurSamenwerkingsovereenkomstOndertekeningsverzoekBatchForEmailGebruikerDto[];
    params?: SamenwerkingsovereenkomstBatchEmailParams;
  },
  TContext
> => {
  const mutationOptions = getSamenwerkingsovereenkomstBatchEmailMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Inregeling.InregelingAanpassen</li></ul>
 * @summary Verstuurt herinneringen voor SWOs die nog niet ondertekend zijn
 */
export const samenwerkingsovereenkomstBatchHerinneringen = (
  params?: MaybeRef<SamenwerkingsovereenkomstBatchHerinneringenParams>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customInstance<CollectionResultOfDocumentenSamenwerkingsovereenkomstVerstuurHerinneringenDto>(
    {
      url: `/api/v1/samenwerkingsovereenkomst/batch/herinneringen`,
      method: 'POST',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getSamenwerkingsovereenkomstBatchHerinneringenMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof samenwerkingsovereenkomstBatchHerinneringen>>,
    TError,
    { params?: SamenwerkingsovereenkomstBatchHerinneringenParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof samenwerkingsovereenkomstBatchHerinneringen>>,
  TError,
  { params?: SamenwerkingsovereenkomstBatchHerinneringenParams },
  TContext
> => {
  const mutationKey = ['samenwerkingsovereenkomstBatchHerinneringen'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof samenwerkingsovereenkomstBatchHerinneringen>>,
    { params?: SamenwerkingsovereenkomstBatchHerinneringenParams }
  > = (props) => {
    const { params } = props ?? {};

    return samenwerkingsovereenkomstBatchHerinneringen(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SamenwerkingsovereenkomstBatchHerinneringenMutationResult = NonNullable<
  Awaited<ReturnType<typeof samenwerkingsovereenkomstBatchHerinneringen>>
>;

export type SamenwerkingsovereenkomstBatchHerinneringenMutationError = ErrorType<void>;

/**
 * @summary Verstuurt herinneringen voor SWOs die nog niet ondertekend zijn
 */
export const useSamenwerkingsovereenkomstBatchHerinneringen = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof samenwerkingsovereenkomstBatchHerinneringen>>,
    TError,
    { params?: SamenwerkingsovereenkomstBatchHerinneringenParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationReturnType<
  Awaited<ReturnType<typeof samenwerkingsovereenkomstBatchHerinneringen>>,
  TError,
  { params?: SamenwerkingsovereenkomstBatchHerinneringenParams },
  TContext
> => {
  const mutationOptions = getSamenwerkingsovereenkomstBatchHerinneringenMutationOptions(options);

  return useMutation(mutationOptions);
};
